const env = process.env;

export const apiList = {
    getDashboardData: 'cmp/api/getDashboard', // 获取大盘图表数据
    getChartsData: 'cmp/api/getdashboardview', // 获取图表区数据
    setUserInfo: 'cmp/api/userinfo', // 首次登陆录入用户信息
    getdashboardlist: 'cmp/api/getdashboardlist', // 获取流水收入数据
    getdashboardexpected: 'cmp/api/getdashboardexpected', // 获取预估流水收入数据
    applyAccount: 'cmp/api/applyaccount', // 申请开户
    getRefusedReasonList: 'cmp/api/refusedreason', // 获取被拒理由
    getAllAccountList: 'cmp/api/auditaccount', // 审核后台获取所有账户列表
    auditAccount: 'cmp/api/auditaccount', // 审核后台获取所有账户列表
    // upload: '//api.amazoncouponhub.com/upload', // 图片上传
    getAppliedList: 'cmp/api/applyaccount', // 用户获取申请的列表
    getEcommerceList: 'cmp/api/ecommerce?type=summery', // 电商信息接口
    getEcommerceChart: 'cmp/api/ecommerce?type=chart', // 电商信息接口
    getoptions: 'cmp/api/getoptions', // 获取查询条件列表
    getamorbdlist: 'cmp/api/getamorbdlist', // 获取查询条件列表
    getLastAccount: 'cmp/api/getlastaccount', // 获取上一次申请填写的信息
    getUserCompanyList: 'cmp/api/usercompany', // 获取公司详情列表
    getUserProductList: 'cmp/api/userproduct', // 获取产品详情列表
    companyDetailEdit: 'cmp/api/usercompany', // 新增/编辑公司详情
    productDetailEdit: 'cmp/api/userproduct', // 新增/编辑产品详情
    getProxy: 'cmp/api/getproxy', // 获取代理名称
    getaccountoverviewchange: 'cmp/api/getaccountoverviewchange', // 账户概览流水数据
    getaccountoverview: 'cmp/api/getaccountoverview', // 账户概览chart data
    getCampaignList: 'cmp/api/getcampaignlist', // 获取广告系列列表
    getAdgroupList: 'cmp/api/getadgrouplist', // 获取广告系列列表
    getAdList: 'cmp/api/getadlist', // 获取广告系列列表
    geturilist: 'cmp/api/geturilist', // 获取uri列表
    createuri: 'cmp/api/createuri',
    updateuri: 'cmp/api/updateuri',
    getrolelist: 'cmp/api/getrolelist',
    createrole: 'cmp/api/createrole',
    updaterole: 'cmp/api/updaterole',
    getmenuapilist: 'cmp/api/getmenuapilist',
    createmenu: 'cmp/api/createmenuapi',
    updatemenu: 'cmp/api/updatemenuapi',
    getUserList: 'cmp/api/getUserList',
    getuserselectorlist: 'cmp/api/getuserselectorlist',
    getrolefield: 'cmp/api/getrolefield', // 表格列数据
    createInvite: 'cmp/api/createinvite ', // 邀请
    sendEmail: 'cmp/api/confirmsendemail', // 确认发送
    getDataDetail: 'cmp/api/getdatadetail', // 广告详情数据
    exportDataDetail: 'cmp/api/exportdatadetail', // 导出广告详情数据
    sendSns: 'cmp/api/sendsns', // 发送短信
    addContact: 'cmp/api/addcountractus', // 保存用户信息
    updateuser: 'cmp/api/updateuser', // 更新用户info
    adduser: 'cmp/api/adduser', // 新增用户
    updateseasonplan: 'cmp/api/updateseasonplan', // 更新财务计收kpi部分数据
    getseasonplan: 'cmp/api/getseasonplan', // 获取财务计收kpi数据
    getfinanceestimate: 'cmp/api/getfinanceestimate', // 获取财务计收全部媒体数据
    updateIncomeRate: 'cmp/api/updateincomerate', // 更新财务计收媒体数据
    exportfinanceestimate: 'cmp/api/exportfinanceestimate', // 导出财务计收媒体数据
    getaccountanalyse: 'cmp/api/getaccountanalyse', // 自动化账户分析dashboard
    getcreativeadvice: 'cmp/api/getcreativeadvice', // 获取素材优化图表数据
    createExportJob: 'cmp/api/createdatajob', // 导出 full report
    exportEcommerce: 'cmp/api/download', // 导出web端电商表格
    getCreativeDataDetail: 'cmp/api/getcreativedatadetail', // 素材列表
    getcreativeDetailInfo: 'cmp/api/getcreative', // 素材详情
    getCreativeDetailCharts: 'cmp/api/getcreativereap', // 素材详情图表数据
    updateCreativeInfo: 'cmp/api/changecreativeinfo', // 更新素材标签
    exportCreativereport: 'cmp/api/createexportjob', // 导出 Creative report
    getDataJobList: 'cmp/api/getdatajoblist', // 获取下载列表
    deleteDataJob: 'cmp/api/deletedatajob', // 删除下载列表
    getReportTemplateList: 'cmp/api/getdetailtemplate', // 获取数据详情报表模板列表
    updateReportTemplateInfo: 'cmp/api/operatedetailtemplate', // 更新模版信息
    getDataDetailView: 'cmp/api/getdatadetailview', // 数据详情可视化
    deleterole: 'cmp/api/deleterole', // 权限管理-删除角色
    getRejectionList: 'cmp/api/getrejectionlist', // 获取素材被拒列表
    markAccountAd: 'cmp/api/markaccountad', // 标记素材
    getMarkList: 'cmp/api/getmarklist', // 查看被拒素材标记列表
    deleteMark: 'cmp/api/deletemark', // 删除标记
    getAccountRoles: 'cmp/api/getaccountroles', // 获取标记账户的用户列表
    updateAccountPending: 'cmp/api/updateaccountpending', // 修改账户状态
    getproxylist: 'cmp/api/getproxylist', // 代理列表
    operateproxyinfo: 'cmp/api/operateproxyinfo', // 新增代理
    getpersonnellist: 'cmp/api/getpersonnellist', // 人员列表管理
    operatepersoninfo: 'cmp/api/operatepersoninfo', // 删除人员账户关联
    sctoken: 'cmp/api/sctoken', // 开户支付方式
    creativelibrary: 'cmp/api/creativelibrary', // 素材库列表
    getentityhistory: 'cmp/api/getentityhistory', // 操作日志
    getaccountbalancelist: 'cmp/api/getaccountbalancelist', // 账户充值列表
    createaccountbalance: 'cmp/api/createaccountbalance', // 账户充值新增&编辑
    createaccountbalancecharge: 'cmp/api/createaccountbalancecharge', // 客户主体充值
    getaccountbalanceinfo: 'cmp/api/getaccountbalanceinfo', // 根据客户主体查询预支款
    getaccountbalancedetail: 'cmp/api/getaccountbalancedetail', // 根据客户主体查询子账户信息
    getchargelist: 'cmp/api/getchargelist', // 账户充值记录
    createchargeinfo: 'cmp/api/createchargeinfo', // 充值
    getaudiencescale: 'cmp/api/getaudiencescale', // 获取媒体预估覆盖用户数据
    createchargewarning: 'cmp/api/createchargewarning', // 充值设置报警
    changeaccount: 'cmp/api/changeaccount', // 账户改名
    getaccounthistory: 'cmp/api/getaccounthistory', // 获取账号字段对应历史
    getentityhourdata: 'cmp/api/getentityhourdata', // 实体小时数据
    getarticlelist: 'cmp/api/getarticlelist', // 帮助文档列表
    savearticle: 'cmp/api/savearticle', // 保存帮助文档
    queryba: 'cmp/api/queryba', // 根据产品查询所属ba
    deletearticle: 'cmp/api/deletearticle', // 删除帮助文档
    quickExport: 'cmp/api/createdatanow', // 数据详情导出url
    uploadExcel: 'cmp/api/uploadcreativeexcel', // 上传广告信息excel
    uploadCreative: 'cmp/api/uploadmedias', // 视频/图片上传
    getUploadCreativeList: 'cmp/api/getcreativeexcellist', // 获取素材上传状态列表
    createCreativeRetry: 'cmp/api/createcreativeretry', // 上传重试
    getaDexcelList: 'cmp/api/getadexcellist', // 获取广告excel列表
    uploadadexcel: 'cmp/api/uploadadexcel', // 上传广告Excel
    createads: 'cmp/api/createads', // 创建最终有效广告
    getcreateadstatus: 'cmp/api/getcreateadstatus', // 获取当前用户创建的状态
    createCreative: 'cmp/api/createcreative', // 创建素材
    getCreateCreativeStatus: 'cmp/api/getcreatecreativestatus' // 获取是否还有上传中的素材
};
export default new Proxy({
    login: 'login',
    auth: 'auth',
    listRule: 'listrule', // 简单规则
    addRule: 'addrule', // 简单规则 - 添加
    deleteRule: 'deleterule', // 简单规则 - 删除
    ...apiList
}, {

    /**
     * 代理每个api路径获取都加上root_api
     * @param  {Object} target 原对象
     * @param  {string} name 要获取的键值
     * @return {string}
     */
    get: (target, name) => {
        return target[name] ? env['ROOT_API'] + '/' + env['MODULE_CMP'] + '/' + target[name] : '';
    }
});



// WEBPACK FOOTER //
// ./src/modules/cmp/constants/api.js